import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';

import { DataBlocks } from 'components';
import { getAccBlockColorTheme, getTopAlertHeading, getTopAlertMessage } from '../../selectors';
import { useAccountStatusAnalytics } from './useAccountStatusAnalytics';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const AccountStatus = () => {
  const { accountStatusRef } = useAccountStatusAnalytics();
  const title = useSelector(getTopAlertHeading);
  const subtitle = useSelector(getTopAlertMessage);
  const colorTheme = useSelector(getAccBlockColorTheme);

  return (
    <div className={cx('component')} ref={accountStatusRef}>
      <DataBlocks.Block
        ariaLabel="Статус аккаунта"
        className={colorTheme}
        title={<span dangerouslySetInnerHTML={{ __html: title }} />}
        subtitle={<span dangerouslySetInnerHTML={{ __html: subtitle }} />}
      />
    </div>
  );
};
